export const state = {
	isLoading: false,
	tituloMenu: 'Inicio',
	urlAtras: '/',
	ocupaAtras: true,
};

export const getters = {
	isLoading: function(state) {
		return state.isLoading;
	},
	getTitulo: function(state) {
		return state.tituloMenu;
	},
	getUrlAtras: function(state) {
		return state.urlAtras;
	},
	getOcupaAtras: function(state) {
		return state.ocupaAtras;
	},
};

export const mutations = {
	SET_LOADING: function(state, newValue) {
		state.isLoading = newValue;
	},
	SET_TITULO: function(state, newValue) {
		state.tituloMenu = newValue;
	},
	SET_URL_ATRAS: function(state, newValue) {
		state.urlAtras = newValue;
	},
	SET_OCUPA_ATRAS: function(state, newValue) {
		state.ocupaAtras = newValue;
	},
};

export const actions = {
	establecerLoading: function({ commit }, loading) {
		commit('SET_LOADING', !!loading);
	},
	establecerTitulo: function({ commit }, loading) {
		commit('SET_TITULO', loading);
	},
	establecerUrlAtras: function({ commit }, urlAtras) {
		commit('SET_OCUPA_ATRAS', !!urlAtras);
		commit('SET_URL_ATRAS', urlAtras);
	},
};
